import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "error"]

  connect() {
    this.clearError()
  }

  validate(event) {
    // On every turbo reload, the ID changes: g-recaptcha-response -> g-recaptcha-response-1
    const recaptchaResponse = document.querySelector('[id^="g-recaptcha-response"]')?.value || ""

    if (recaptchaResponse.length === 0) {
      event.preventDefault()
      this.showError("Please solve the captcha below")
    } else {
      this.clearError()
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }
}
